<template>
    <ResourceInput
        label="Summary"
        attribute="summary"
        type="textarea"
    />
</template>
